import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const Accommodation = () => {
  return (
    <>
        <Box className="headingBtnWrap">
            <Typography variant="h1">Accommodation</Typography>
        </Box>
    </>
  )
}

export default Accommodation
